.text-container {
    max-width: 600px;
    text-align: center;
}
